import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assignFormRole: [],
  assignFormType: [],
  assignFormOrganizations: [],
  assignFormUsers: [],
  assignFormUserGroups: [],
  assignFormClinics: [],
  isRecurring: false,
  allOrgAccess: false,
  assignFormStartDate: new Date().toISOString().split("T")[0],
  assignFormEndDate: new Date().toISOString().split("T")[0],
  selected_timezone: "UTC",
};

export const assignSlice = createSlice({
  name: "assign",
  initialState,
  reducers: {
    setAssignSliceData: (state, { payload }) => {
      Object.keys(payload).forEach((key) => {
        if (key in initialState) {
          state[key] = payload[key];
        }
      });
    },
    resetFeedCreateData: (state, {}) => {
      state.assignFormRole = [];
      state.assignFormType = [];
      state.assignFormOrganizations = [];
      state.assignFormUsers = [];
      state.assignFormUserGroups = [];
      state.assignFormClinics = [];
      state.isRecurring = false;
      state.assignFormStartDate = new Date().toISOString().split("T")[0];
      state.assignFormEndDate = new Date().toISOString().split("T")[0];
      state.selected_timezone = "UTC";
    },
    toggleRoles: (state, action) => {
      // if payload exists in selectedRoles, remove it else add it
      if (
        state.assignFormRole.find((role) => role.code === action.payload.code)
      ) {
        state.assignFormRole = state.assignFormRole.filter(
          (role) => role.code !== action.payload.code
        );
      } else {
        state.assignFormRole.push(action.payload);
      }
    },
    toggleTypes: (state, action) => {
      // if payload exists in selectedTypes, remove it else add it
      if (
        state.assignFormType.find((type) => type.code === action.payload.code)
      ) {
        state.assignFormType = state.assignFormType.filter(
          (type) => type.code !== action.payload.code
        );
      } else {
        state.assignFormType.push(action.payload);
      }
    },
    toggleOrganizations: (state, action) => {
      // if payload exists in selectedOrganizations, remove it else add it
      if (
        state.assignFormOrganizations.find(
          (organization) => organization.org_id === action.payload.org_id
        )
      ) {
        state.assignFormOrganizations = state.assignFormOrganizations.filter(
          (organization) => organization.org_id !== action.payload.org_id
        );
      } else {
        state.assignFormOrganizations.push(action.payload);
      }
    },
    toggleUsers: (state, action) => {
      // if payload exists in selectedUsers, remove it else add it
      if (
        state.assignFormUsers.find(
          (user) => user.user_id === action.payload.user_id
        )
      ) {
        state.assignFormUsers = state.assignFormUsers.filter(
          (user) => user.user_id !== action.payload.user_id
        );
      } else {
        state.assignFormUsers.push(action.payload);
      }
    },
    toggleUserGroups: (state, action) => {
      // if payload exists in assignFormUserGroups, remove it else add it
      if (
        state.assignFormUserGroups.find(
          (userGroup) => userGroup.group_id === action.payload.group_id
        )
      ) {
        state.assignFormUserGroups = state.assignFormUserGroups.filter(
          (userGroup) => userGroup.group_id !== action.payload.group_id
        );
      } else {
        state.assignFormUserGroups.push(action.payload);
      }
    },
    toggleClinics: (state, action) => {
      // if payload exists in assignFormClinics, remove it else add it
      if (
        state.assignFormClinics.find(
          (clinic) => clinic.id === action.payload.id
        )
      ) {
        state.assignFormClinics = state.assignFormClinics.filter(
          (clinic) => clinic.id !== action.payload.id
        );
      } else {
        state.assignFormClinics.push(action.payload);
      }
    },
  },
});

export const {
  setAssignSliceData,
  resetFeedCreateData,
  toggleRoles,
  toggleTypes,
  toggleOrganizations,
  toggleUsers,
  toggleUserGroups,
  toggleClinics,
} = assignSlice.actions;
export default assignSlice.reducer;
